import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource-variable/albert-sans";
import "@fontsource/spectral/200.css";
import "./styles.css";
import { App } from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
